<mat-form-field class="iban-form-field">
  <input
    appIban
    ibanValidator
    matInput
    [disabled]="props.disabled ?? false"
    [type]="'text'"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [value]="formControl.value | ibanFormatter"
  />
  @if (formControl.hasError('required')) {
    <mat-error> {{ 'labels.required' | translate }} </mat-error>
  }
  @if (formControl.hasError('ibanInvalid')) {
    <mat-error> {{ 'payments.invalid-iban' | translate }} </mat-error>
  }
</mat-form-field>
